const repAiButton = (element, callback) => {
    const maxWaitTime = 7000;
    const interval = 90;
    let elapsedTime = 0;

    const waitingInterval = setInterval(() => {
        const selector = document.querySelector(element);
        if (selector) {
            callback();
            clearInterval(waitingInterval);
        } else {
            elapsedTime += interval;
            if (elapsedTime >= maxWaitTime) {
                clearInterval(waitingInterval);
            }
        }
    }, interval);
};

repAiButton("#repWebClientContainer", () => {

    rep.hide();

    rep.on('close', () => {
        rep.hide();
    })

    rep.on('open', () => {
        rep.show();
    });

    document.querySelector("#CustomRepChatButton").classList.add("visible");
    document.querySelector("#CustomRepChatButtonMobile").classList.add("visible");
    
});